import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { filterInvalidImages } from "@faire/retailer-visitor-shared/lib/filterInvalidImages";
import { isFastly } from "@faire/web--source/common/images/optimizeImages";
import { useQuery } from "@tanstack/react-query";
export var useValidateImage = function(image) {
    var _useQuery = useQuery({
        queryKey: [
            "validate-image-result",
            image,
            image === null || image === void 0 ? void 0 : image.url
        ],
        queryFn: /*#__PURE__*/ _async_to_generator(function() {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!((image === null || image === void 0 ? void 0 : image.url) && !isFastly(image.url))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            filterInvalidImages([
                                image
                            ])
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()[0]
                        ];
                    case 2:
                        return [
                            2,
                            image
                        ];
                }
            });
        })
    }), validateImageData = _useQuery.data;
    if (!(image === null || image === void 0 ? void 0 : image.url)) {
        return undefined;
    }
    return validateImageData;
};
